import { FC } from 'react';
import ApartmentCard from '../apartmentCard';
import HotelCard from '../hotelCard';
import RealEstateCard from '../realEstateCard';
import RestaurantCard from '../restaurantCard';

const cardsMap: Record<string, FC<any>> = {
  apartments: ApartmentCard,
  hotels: HotelCard,
  constructors: RealEstateCard,
  restaurants: RestaurantCard,
};

export const getCardRenderer = (category: string) => cardsMap[category];
